module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "p2222 card card-square"
  }, [_vm._v("\n    " + _vm._s(_vm.data) + "\n  ")]), _vm._v(" "), _c('keyboard', {
    model: {
      value: (_vm.data),
      callback: function($$v) {
        _vm.data = $$v
      },
      expression: "data"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-54250751!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/keyboard/demo.vue
// module id = 250
// module chunks = 29